export enum ApprovalSubType {
    InBudget = 10,
    OutOfBudget = 20,
    TwelveMonthsPC = 30,
    CompletedProject = 40,
    Stock = 50,
    CapitalSpend = 60,
}
